export const GuildGroupTypes = {
  DEFAULT: 1
};
export const GroupTypes = {
  GUILD: 1,
  MYTHICPLUS: 2,
  EVENT: 3
};

export const enum MythicGroupCharterLimits {
  Default = 2,
  Patron_Revered = 3,
  Patron_Exalted = 4,
  Patron_Illustrious = 5
}

export const enum ROLE_GRANT {
  CAN_EDIT_PROFILE = 'canEditProfile',
  CAN_EDIT_PRIVACY = 'canEditPrivacy',
  CAN_MANAGE_ROLES = 'canManageRoles',
  CAN_MANAGE_RECRUITMENT = 'canManageRecruitment',
  CAN_EDIT_BLOCK_LIST = 'canEditBlockList',
  CAN_MANAGE_VIDEOS = 'canManageVideos',
  CAN_VIEW_CLIENT_USAGE = 'canViewClientUsage'
}

// should only have values set to true - the permissions allowed by a role
const ROLE_PERMISSIONS: { [key: string]: { [grant: string /*ROLE_GRANT*/]: true } } = {
  admin: {
    [ROLE_GRANT.CAN_EDIT_PROFILE]: true,
    [ROLE_GRANT.CAN_EDIT_PRIVACY]: true,
    [ROLE_GRANT.CAN_MANAGE_ROLES]: true,
    [ROLE_GRANT.CAN_MANAGE_RECRUITMENT]: true,
    [ROLE_GRANT.CAN_EDIT_BLOCK_LIST]: true,
    [ROLE_GRANT.CAN_MANAGE_VIDEOS]: true,
    [ROLE_GRANT.CAN_VIEW_CLIENT_USAGE]: true
  },
  officer: {
    [ROLE_GRANT.CAN_EDIT_PROFILE]: true,
    [ROLE_GRANT.CAN_EDIT_PRIVACY]: true,
    [ROLE_GRANT.CAN_MANAGE_ROLES]: true,
    [ROLE_GRANT.CAN_MANAGE_RECRUITMENT]: true,
    [ROLE_GRANT.CAN_EDIT_BLOCK_LIST]: true,
    [ROLE_GRANT.CAN_MANAGE_VIDEOS]: true,
    [ROLE_GRANT.CAN_VIEW_CLIENT_USAGE]: true
  },
  recruiter: {
    [ROLE_GRANT.CAN_EDIT_PROFILE]: true,
    [ROLE_GRANT.CAN_MANAGE_RECRUITMENT]: true,
    [ROLE_GRANT.CAN_EDIT_BLOCK_LIST]: true
  },
  profile_manager: {
    [ROLE_GRANT.CAN_EDIT_PROFILE]: true
  },
  video_manager: {
    [ROLE_GRANT.CAN_MANAGE_VIDEOS]: true
  }
};

export function getRolePermissions(role: string) {
  return ROLE_PERMISSIONS[role] || {};
}

export function getPermissionsForRoles(roles: string[]) {
  return roles.reduce((accum: { [grant: string /*ROLE_GRANT*/]: true }, role: string) => {
    accum = { ...accum, ...getRolePermissions(role) };
    return accum;
  }, {});
}

export function getRolesForGrant(grant: ROLE_GRANT): string[] {
  const allowedRoles = [];

  for (const [role, permissions] of Object.entries(ROLE_PERMISSIONS)) {
    if (permissions[grant]) {
      allowedRoles.push(role);
    }
  }

  return allowedRoles;
}

export const CHARTER_MIN_PLAYERS = 5;

export enum GroupFlags {
  COMPETITION_GUILD = 1
}
